module.exports = __webpack_public_path__ + "img/ecuador.e87ae801.svg";